import { ReactNode } from 'react'
import { motion } from 'framer-motion'

interface PageContainerProps {
  children: ReactNode
  className?: string
  noPadding?: boolean
}

export function PageContainer({ children, className = '', noPadding = false }: PageContainerProps) {
  return (
    <motion.main
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      className={`flex-1 ${noPadding ? '' : 'px-4'} pb-24 ${className}`}
    >
      {children}
    </motion.main>
  )
}
